"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressFormat = function (num) {
    return num >= 99 ? Math.floor(num) : Math.ceil(num);
};
exports.default = { progressFormat: exports.progressFormat };
